import { render } from "./agentList.vue?vue&type=template&id=a0aba232&scoped=true"
import script from "./agentList.vue?vue&type=script&lang=js"
export * from "./agentList.vue?vue&type=script&lang=js"

import "./agentList.vue?vue&type=style&index=0&id=a0aba232&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0aba232"]])

export default __exports__